/* Media / press kit page behaviour. Loaded only by templates/page.media.liquid. */

function createPressBanner(publicationName, articleUrl, bannerClass, nameClass) {
  const banner = document.createElement('div');
  banner.className = bannerClass;

  const stack = document.createElement('div');
  stack.className = bannerClass === 'press-thumb-banner' ? 'press-thumb-stack' : 'plc-thumb-stack';

  const name = document.createElement('div');
  name.className = nameClass;
  name.textContent = publicationName || 'Kaayu Rituals';

  stack.appendChild(name);
  banner.appendChild(stack);
  return banner;
}

function createThumbImage(className = 'press-thumb-img') {
  const img = document.createElement('img');
  img.className = className;
  img.alt = '';
  img.loading = 'lazy';
  img.decoding = 'async';
  return img;
}

function resolveUrlMaybeRelative(url, baseUrl) {
  if (!url) return null;
  try {
    return new URL(url, baseUrl).toString();
  } catch (error) {
    return null;
  }
}

function getImageWidthHint(img) {
  const attrWidth = Number(img.getAttribute('width')) || 0;
  const dataWidth = Number(img.getAttribute('data-width')) || 0;
  const srcset = img.getAttribute('srcset') || '';
  const src = img.getAttribute('src') || '';
  const candidates = [...srcset.matchAll(/(\d+)w/g)].map((match) => Number(match[1]));
  const mediumMatch = src.match(/resize:fit:(\d+)/i);
  if (mediumMatch) candidates.push(Number(mediumMatch[1]));
  return Math.max(attrWidth, dataWidth, ...candidates, 0);
}

function isRejectedImageUrl(url) {
  return /(logo|icon|favicon|avatar|profile|brand|sprite|pixel|tracking|1x1|badge)/i.test(url);
}

function getCandidateImageUrl(img, articleUrl) {
  return resolveUrlMaybeRelative(
    img.getAttribute('src') || img.getAttribute('data-src') || img.getAttribute('data-original'),
    articleUrl
  );
}

function findMediumImage(doc, articleUrl) {
  const images = Array.from(doc.querySelectorAll('img'));
  for (const img of images) {
    const imageUrl = getCandidateImageUrl(img, articleUrl);
    if (!imageUrl || !/miro\.medium\.com/i.test(imageUrl)) continue;
    if (/fit:0/i.test(imageUrl)) continue;
    if (getImageWidthHint(img) < 200 && !/resize:fit:(\d{3,})/i.test(imageUrl)) continue;
    return imageUrl;
  }
  return null;
}

function findScopedArticleImage(doc, articleUrl) {
  const scopedRoot = doc.querySelector('article, main, [role="main"], .post-content, .article-body');
  if (!scopedRoot) return null;

  const images = Array.from(scopedRoot.querySelectorAll('img'));
  for (const img of images) {
    const imageUrl = getCandidateImageUrl(img, articleUrl);
    if (!imageUrl || isRejectedImageUrl(imageUrl)) continue;
    if (getImageWidthHint(img) > 400) return imageUrl;
  }

  return null;
}

function findKaayuImage(doc, articleUrl) {
  const images = Array.from(doc.querySelectorAll('img'));
  for (const img of images) {
    const imageUrl = getCandidateImageUrl(img, articleUrl);
    if (imageUrl && /kaayu/i.test(imageUrl)) return imageUrl;
  }
  return null;
}

function findGenericContentImage(doc, articleUrl) {
  const images = Array.from(doc.querySelectorAll('img'));
  for (const img of images) {
    const imageUrl = getCandidateImageUrl(img, articleUrl);
    if (!imageUrl || isRejectedImageUrl(imageUrl)) continue;
    return imageUrl;
  }

  return null;
}

function extractImageFromHtml(html, articleUrl) {
  const doc = new DOMParser().parseFromString(html, 'text/html');

  if (/medium\.com/i.test(articleUrl)) {
    const mediumImage = findMediumImage(doc, articleUrl);
    if (mediumImage) return mediumImage;
  }

  const ogImage = resolveUrlMaybeRelative(
    doc.querySelector('meta[property="og:image"]')?.getAttribute('content'),
    articleUrl
  );
  if (ogImage) return ogImage;

  const twitterImage = resolveUrlMaybeRelative(
    doc.querySelector('meta[name="twitter:image"], meta[property="twitter:image"]')?.getAttribute('content'),
    articleUrl
  );
  if (twitterImage) return twitterImage;

  const scopedImage = findScopedArticleImage(doc, articleUrl);
  if (scopedImage) return scopedImage;

  const kaayuImage = findKaayuImage(doc, articleUrl);
  if (kaayuImage) return kaayuImage;

  return findGenericContentImage(doc, articleUrl);
}

async function fetchArticleHtml(articleUrl) {
  const response = await fetch(`https://corsproxy.io/?url=${encodeURIComponent(articleUrl)}`);
  if (!response.ok) throw new Error(`Proxy failed: ${response.status}`);
  return response.text();
}

async function fetchImageFromArticle(articleUrl) {
  if (!articleUrl || articleUrl === '#' || articleUrl.startsWith('#')) return null;

  try {
    const html = await fetchArticleHtml(articleUrl);
    return extractImageFromHtml(html, articleUrl);
  } catch (error) {
    return null;
  }
}

function ensurePressThumbnails() {
  document.querySelectorAll('#press .press-card').forEach((card) => {
    if (card.querySelector('.press-thumb')) return;

    const thumb = document.createElement('div');
    thumb.className = 'press-thumb';
    thumb.dataset.url = card.getAttribute('href') || '';
    thumb.dataset.publication = card.querySelector('.press-pub-name')?.textContent.trim() || '';
    thumb.dataset.title = card.querySelector('.press-quote')?.textContent.trim() || '';
    thumb.appendChild(createThumbImage('press-thumb-img'));
    thumb.appendChild(
      createPressBanner(
        card.querySelector('.press-pub-name')?.textContent.trim(),
        card.getAttribute('href') || '',
        'press-thumb-banner',
        'press-thumb-name'
      )
    );

    const overlay = document.createElement('div');
    overlay.className = 'press-thumb-overlay';

    thumb.appendChild(overlay);
    card.insertBefore(thumb, card.querySelector('.press-card-top'));
  });

  document.querySelectorAll('#press .plc-thumb').forEach((thumb) => {
    if (thumb.querySelector('.plc-thumb-banner')) return;

    const card = thumb.closest('.press-list-card');
    thumb.dataset.url = card?.getAttribute('href') || '';
    thumb.dataset.publication = thumb.querySelector('.plc-pub-badge')?.textContent.trim() || '';
    thumb.dataset.title = card?.querySelector('.plc-title')?.textContent.trim() || '';
    thumb.insertBefore(createThumbImage('plc-thumb-img'), thumb.firstChild);
    thumb.insertBefore(
      createPressBanner(
        thumb.querySelector('.plc-pub-badge')?.textContent.trim() || card?.querySelector('.plc-title')?.textContent.trim(),
        card?.getAttribute('href') || '',
        'plc-thumb-banner',
        'plc-thumb-name'
      ),
      thumb.firstChild
    );
  });
}

async function loadPressThumbnail(thumb) {
  const articleUrl = thumb.dataset.url;
  const img = thumb.querySelector('.press-thumb-img, .plc-thumb-img');
  if (!img) return;

  if (!articleUrl || articleUrl === '#' || articleUrl.startsWith('#')) {
    thumb.classList.remove('is-loading');
    return;
  }

  thumb.classList.add('is-loading');
  const thumbnailSrc = await fetchImageFromArticle(articleUrl);

  if (!thumbnailSrc) {
    thumb.classList.remove('is-loading');
    return;
  }

  await new Promise((resolve) => {
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = thumbnailSrc;
  }).then((didLoad) => {
    thumb.classList.remove('is-loading');
    if (didLoad) {
      thumb.classList.add('is-loaded');
      return;
    }

    img.removeAttribute('src');
    thumb.classList.remove('is-loaded');
  });
}

function loadPressThumbnails() {
  const thumbs = Array.from(document.querySelectorAll('#press .press-thumb, #press .plc-thumb'));
  thumbs.forEach((thumb) => {
    loadPressThumbnail(thumb);
  });
}

function syncPressContainers(containers) {
  containers.forEach((container) => {
    const hasVisibleCards = Array.from(container.children).some(
      (child) => window.getComputedStyle(child).display !== 'none'
    );
    container.style.display = hasVisibleCards ? 'grid' : 'none';
  });
}

document.addEventListener('DOMContentLoaded', function () {
  var moreNews = document.getElementById('more-news');
  var loadMoreBtn = document.getElementById('view-more-btn');
  var pressSection = document.getElementById('press');

  if (!moreNews || !loadMoreBtn) return;

  // Initial state: hide the extra cards, show Load More button
  moreNews.style.display = 'none';
  loadMoreBtn.innerHTML = 'LOAD MORE &rarr;';
  loadMoreBtn.style.display = 'inline-flex';

  // Create Show Less button
  var showLessBtn = document.createElement('button');
  showLessBtn.id = 'show-less-btn';
  showLessBtn.type = 'button';
  showLessBtn.innerHTML = 'SHOW LESS &uarr;';
  showLessBtn.style.cssText = loadMoreBtn.style.cssText;
  showLessBtn.style.display = 'none';
  showLessBtn.style.fontSize = '0.72rem';
  showLessBtn.style.letterSpacing = '0.16em';
  showLessBtn.style.textTransform = 'uppercase';
  showLessBtn.style.padding = '0.85rem 2.8rem';
  showLessBtn.style.background = 'transparent';
  showLessBtn.style.border = '1px solid var(--gold)';
  showLessBtn.style.color = 'var(--gold)';
  showLessBtn.style.cursor = 'pointer';
  showLessBtn.style.fontFamily = "'Jost', sans-serif";
  showLessBtn.style.fontWeight = '500';
  loadMoreBtn.parentElement.appendChild(showLessBtn);

  document.querySelectorAll('.press-list-card').forEach(card => {
    const href = card.getAttribute('href') || '';
    const dataDomain = card.getAttribute('data-domain') || '';
    let domain = dataDomain;
    if (!domain) {
      try { domain = new URL(href).hostname.replace('www.',''); } catch(e){}
    }
    const date = card.dataset.date || '';
    const meta = card.querySelector('.plc-meta');
    const firstMetaText = meta && meta.firstElementChild ? meta.firstElementChild.textContent.trim() : '';
    if (meta && date && !meta.querySelector('.date-added') && firstMetaText !== date) {
      const dateSpan = document.createElement('span');
      dateSpan.className = 'date-added';
      dateSpan.textContent = date;
      meta.insertBefore(dateSpan, meta.firstChild);
    }
    if (domain) {
      const footer = card.querySelector('.plc-footer');
      if (footer && !footer.querySelector('img')) {
        const logo = document.createElement('img');
        logo.src = 'https://www.google.com/s2/favicons?domain=' + domain + '&sz=64';
        logo.style.cssText = 'width:32px;height:32px;border-radius:6px;object-fit:contain;flex-shrink:0;';
        footer.appendChild(logo);
      }
    }
  });

  loadMoreBtn.onclick = function () {
    moreNews.style.display = 'block';
    loadMoreBtn.style.display = 'none';
    showLessBtn.style.display = 'inline-flex';
    ensurePressThumbnails();
    loadPressThumbnails();
  };

  showLessBtn.onclick = function () {
    moreNews.style.display = 'none';
    loadMoreBtn.style.display = 'inline-flex';
    showLessBtn.style.display = 'none';
    if (pressSection) pressSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // Load thumbnails for the always-visible cards
  ensurePressThumbnails();
  loadPressThumbnails();
});
var extendedCurrentGroup = 1;
var extendedTotalGroups = 4;

document.addEventListener('DOMContentLoaded', function() {
  var btn = document.getElementById('extended-load-more');
  if (!btn) return;
  btn.addEventListener('click', function() {
    var group = document.getElementById('group-' + extendedCurrentGroup);
    if (group) {
      group.style.display = 'grid';
      extendedCurrentGroup++;
    }
    if (extendedCurrentGroup > extendedTotalGroups) {
      btn.style.display = 'none';
    }
  });
});
function submitPRForm() {
  const name = document.getElementById('f-name').value.trim();
  const email = document.getElementById('f-email').value.trim();
  const pub = document.getElementById('f-pub').value.trim();
  const enquiryType = document.getElementById('f-type').value.trim() || 'Not specified';
  const message = document.getElementById('f-msg').value.trim() || 'Not provided';
  if (!name || !email || !pub) {
    alert('Please fill in your name, email, and publication before submitting.');
    return;
  }
  const recipients = 'info@kaayurituals.com,anjanjyot@garagecollective.agency';
  const subject = encodeURIComponent(`PR Enquiry from ${name}`);
  const body = encodeURIComponent(
    `Name: ${name}\n` +
    `Email: ${email}\n` +
    `Publication / Platform: ${pub}\n` +
    `Type of Enquiry: ${enquiryType}\n\n` +
    `Message:\n${message}`
  );
  window.location.href = `mailto:${recipients}?subject=${subject}&body=${body}`;
  document.getElementById('form-success').style.display = 'block';
}
